import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ContaCaixaConfiguracao } from '../../../models/conta-caixa-configuracao';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';
import { MesclarContasRetorno } from '../../../models/mesclar-contas-retorno';

@Component({
  selector: 'app-mesclar-contas-dialog',
  standalone: false,
  templateUrl: './mesclar-contas-dialog.component.html',
  styleUrl: './mesclar-contas-dialog.component.scss'
})
export class MesclarContasDialogComponent {

  title: string = 'Mesclar Contas';
  contas: ContaCaixaConfiguracao[] = [];
  contaAtual?: ContaCaixaConfiguracao;
  contaSelecionada?: ContaCaixaConfiguracao;
  nomeFinal: string = '';
  dataLancamentoConciliado: Date | null = null;

  get naoExisteContaComBanco(): boolean { return !this.contaAtual?.contaBancoId && !this.contaSelecionada?.contaBancoId }
  get tooltipContent(): string {
    if (this.naoExisteContaComBanco) {
      return `Não há conta do banco nas contas do caixa selecionadas. 
              Não é necessário ajustar a conciliação.`;
    } 
    else {
      let nomeConta : string;
      if (this.contaAtual?.contaBancoId)
        nomeConta = this.contaSelecionada ? this.contaSelecionada?.nome : "selecionada";
      else
        nomeConta = this.contaAtual!.nome;

      return `Lançamentos da conta "${nomeConta}" anteriores a esta data serão conciliados automaticamente após a mesclagem.
      Deixe em branco para não conciliar nenhum.`;
    }
  }

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<MesclarContasDialogComponent>
  ) { }

  public onSelectionChange(): void {
    this.nomeFinal = this.contaSelecionada?.nome ?? "";
  }

  public salvarClick(): void {
    if (!this.contaSelecionada) {
      this.messageService.showToastWarning('Selecione uma conta destino para a mesclagem');
      return;
    }
    if (this.contaSelecionada.contaBancoId && this.contaAtual?.contaBancoId) {
      this.messageService.showToastWarning('Não é possivel mesclar duas contas do caixa vinculadas a contas do banco');
      return;
    }
    if (this.contaSelecionada.id == this.contaAtual?.id) {
      this.messageService.showToastWarning('A conta selecionada é a mesma que a conta que será mesclada');
      return;
    }
    if (!this.nomeFinal?.trim()) {
      this.messageService.showToastWarning('O nome da conta não pode ser vazio');
      return;
    }

    const retorno: MesclarContasRetorno = {
      contaOrigemId: this.contaAtual!.id,
      contaDestinoId: this.contaSelecionada!.id,
      nomeFinal: this.nomeFinal,
      dataLancamentoConciliado: this.dataLancamentoConciliado
    }

    this.configuracaoCaixaApiService.mesclarContasCaixa(retorno).subscribe(() => {
      this.messageService.showToastSuccess("Salvo com sucesso");
      this.dialogRef.close(true);
    });
  }
}
